export enum SearchTypeEnum {
    PROJECT,
    // CAMERA,
    // CAMERA_CCTV,
    USER,
    CLIENT,
}
